export default __webpack_public_path__ + "static/gustav-e310f15c4c52d1afd0523f105fa05dd2.jpg";